// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import implementationMilestoneEntity from './entities/implementation-milestone.json';
import implementationMilestoneMenu from '../pages/implementation-milestone/menu.json';
import implementationMilestoneFullForm from '../pages/implementation-milestone/forms/full.json';
import implementationMilestoneContextForm from '../pages/implementation-milestone/forms/context.json';
import implementationMilestoneMiniForm from '../pages/implementation-milestone/forms/mini.json';
import implementationMilestoneLookupForm from '../pages/implementation-milestone/forms/lookup.json';
import implementationMilestoneTableView from '../pages/implementation-milestone/views/table.json';
import implementationMilestoneCardsView from '../pages/implementation-milestone/views/cards.json';
import implementationMilestoneDashboardView from '../pages/implementation-milestone/views/dashboard.json';

/** Тип запису «Віха впровадження» зі сторінками пакета: меню, форми та подання з pages/implementation-milestone/. */
export const implementationMilestoneDefinition: IRecordTypeDefinition = {
  ...implementationMilestoneEntity,
  views: assembleViewSet({
      table: implementationMilestoneTableView,
      cards: implementationMilestoneCardsView,
      dashboard: implementationMilestoneDashboardView,
  }),
  form: implementationMilestoneFullForm,
  forms: { full: implementationMilestoneFullForm, context: implementationMilestoneContextForm, mini: implementationMilestoneMiniForm, lookup: implementationMilestoneLookupForm },
  menu: implementationMilestoneMenu,
} as IRecordTypeDefinition;
